import React from 'react';
import { Home, MapPin, Clock } from 'lucide-react';
export function ShippingSection() {
  return <section className="bg-gradient-to-b from-dark-900 via-dark-800 to-dark-900 py-[70px] px-5" id="envios" data-id="element-414" data-mp="2c2wz4s71z871">
      <div className="max-w-[1100px] mx-auto" data-id="element-415" data-mp="2gvhmbavgen1l">
        <h2 className="text-[2.2rem] font-black text-center mb-2.5 uppercase tracking-[2px] text-white" data-id="element-416" data-mp="2lt9ocxptbpji">
          Envíos & Pick Up
        </h2>
        <p className="text-center text-[#aaa] mb-[50px] text-[1.05rem]" data-id="element-417" data-mp="1o6suk2gafu2i">
          Simple, rápido y al mejor precio de Montevideo
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 mt-10" data-id="element-418" data-mp="1t6f709oal6a9">
          <div className="flex flex-col items-center bg-dark-600 border border-dark-400 rounded-md p-[30px_25px] text-center" data-id="element-419" data-mp="1y241hylgfwzp">
            <Home className="w-10 h-10 text-alphaGold mb-[15px]" data-id="element-420" data-mp="222xp0quzj9s2" />
            <h3 className="text-[1rem] font-extrabold uppercase tracking-[1px] text-white mb-2.5" data-id="element-421" data-mp="39iaps108a0fa">
              Envío a Domicilio
            </h3>
            <span className="text-alphaGold text-[1.4rem] font-black block my-2.5" data-id="element-422" data-mp="1d9ff6prgncs5">
              Desde $190 UY
            </span>
            <p className="text-[#888] text-[0.9rem] leading-[1.6]" data-id="element-423" data-mp="18bmbc3dmquv1">
              Costo varía según tu zona en Montevideo. Lo calculamos al
              confirmar tu pedido por WhatsApp.
            </p>
          </div>

          <div className="flex flex-col items-center bg-dark-600 border border-dark-400 rounded-md p-[30px_25px] text-center" data-id="element-424" data-mp="z9cxb3j5kjcw">
            <MapPin className="w-10 h-10 text-alphaGold mb-[15px]" data-id="element-425" data-mp="ucmmovq4afyv" />
            <h3 className="text-[1rem] font-extrabold uppercase tracking-[1px] text-white mb-2.5" data-id="element-426" data-mp="piiek95481w7">
              Pick Up
            </h3>
            <span className="text-alphaGold text-[1.4rem] font-black block my-2.5" data-id="element-427" data-mp="flx8dkhd0kqs">
              ¡Sin costo!
            </span>
            <p className="text-[#888] text-[0.9rem] leading-[1.6]" data-id="element-428" data-mp="bklf94za1hdu">
              Vení a buscarlo directamente a{' '}
              <strong className="text-white" data-id="element-429" data-mp="6mjtudedp5z7">Malvín, Montevideo</strong>. Te
              esperamos de Lun a Sáb.
            </p>
          </div>

          <div className="flex flex-col items-center bg-dark-600 border border-dark-400 rounded-md p-[30px_25px] text-center" data-id="element-430" data-mp="z899jr0s9kx">
            <Clock className="w-10 h-10 text-alphaGold mb-[15px]" data-id="element-431" data-mp="3j5cxlw85oee5" />
            <h3 className="text-[1rem] font-extrabold uppercase tracking-[1px] text-white mb-2.5" data-id="element-432" data-mp="3j75zky7tqaft">
              Horario de Atención
            </h3>
            <span className="text-alphaGold text-[1rem] font-black block my-2.5" data-id="element-433" data-mp="fp5txppqqh5d">
              Lun — Sáb
            </span>
            <p className="text-[#888] text-[0.9rem] leading-[1.6]" data-id="element-434" data-mp="kme9diji872x">
              De <strong className="text-white" data-id="element-435" data-mp="5x9oftlbror4">10:00 a 18:00 horas</strong>.
              <br data-id="element-436" data-mp="awupqanyw970" />
              Domingo: cerrados.
            </p>
          </div>
        </div>
      </div>
    </section>;
}